import { Table as TableAnt, TableProps } from "antd";
import styled from "styled-components";

export const Table: typeof TableAnt = styled(TableAnt)<
  TableProps<any>
>`` as any;
